import React from 'react'

export const AlreadySignedMessage = () => {
  return (
    <div
      style={{
        padding: 10,
        textAlign: 'center',
        display: 'table-cell',
        wordWrap: 'break-word',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'baseline',
        fontWeight: '700',
      }}>
      <h1>Ce document a déjà été signé. Vous pouvez désormais fermer cette fenêtre.</h1>
    </div>
  )
}
